import Urls from 'Containers/Urls';

const URLS_REMAP = {
  [Urls.home]: 'home_page',
  [Urls.channels]: 'payment_code',
  [Urls.codeChannel]: 'payment_code',
  [Urls.movements]: 'activity',
  [Urls.statements]: 'profile',
  [Urls.verifyAccount]: 'email_verification',
};

// convert values to keys and keys to values
const URLS = Object
  .entries(Urls)
  .reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {} as Record<string, string>);

export default function screenName(slug: string | null) {
  if (slug && slug in URLS_REMAP) return URLS_REMAP[slug];
  if (slug && slug in URLS) return URLS[slug];
  return 'other';
}
